<template>
	<div>
		<b-container fluid v-if="draw_fields.length > 0" class="border insd border-top-0 p-3">
			<b-row cla ss="doc_title" >
				<b-col sm="12">
					<b-row class="doc_title mt-2" v-for="field in draw_fields" :key="field.id">
						<b-col sm="3">
							<label :for="field.field_type + field.id">
								{{field.field_name}}
							</label>
						</b-col>

						<b-col sm="9">
							<b-form-input
								type="text"
								class="fs-xl"
								:disabled="true"
								v-model="field.field_val_to_show"
								size="sm" >
							</b-form-input>
						</b-col>
					</b-row>
				</b-col>
			</b-row>


			<div id="panel-12" class="panel mt-5">
				<b-overlay :show="!finish_load" rounded="xl">
					<div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
						<h2>
							Додаткова  <span class="fw-300">Інформація</span>
						</h2>

						<div class="panel-toolbar pr-3 align-self-end">
							<ul id="demo_panel-tabs" class="nav nav-tabs border-bottom-0" role="tablist">

								<li class="nav-item" v-for="tab in this.active_tabs">
									<a class="nav-link cursor-pointer" v-on:click="setActiveTab(tab.type)" :class="{'active' : tab.is_active}" >
										{{tab.name}}
									</a>
								</li>
							</ul>
						</div>
					</div>

					<div class="panel-container show">
						<div class="panel-content">
							<data_1c
								:owner="owner"
								:addon_fields="this.draw_fields"
								:data="pai_info.data_1c" v-if="current_tab.type === '1c'">
							</data_1c>

							<!--
							<data_panorama
								:owner="owner"
								:addon_fields="this.draw_fields"
								:data="pai_info.data_panorama" v-if="current_tab.type === 'panorama'">
							</data_panorama>
							-->

							<pai_map
								:map_id="this.kadastr_v"
								:owner="owner"
								:addon_fields="this.draw_fields"
								:data_1c="pai_info.data_1c"
								:data_panorama="pai_info.data_panorama"
								v-if="current_tab.type === 'map'"
							>

							</pai_map>

						</div>
					</div>
				</b-overlay>
			</div>
		</b-container>
	</div>

</template>

<script>


import Data_1c from "../tabs/data_1c";
import Data_panorama from "../tabs/data_panorama";
import Pai_map from "../tabs/pai_map";

export default {
	name: "pai_tab",
	components: { Pai_map, Data_panorama, Data_1c},

	props : {
		pai_item : {
			type : Object
		},

		owner : {
			type : String,
			default : "",
		},
	},

	data() {
		return {
			loading_unit: false,

			active_tabs : [
				{type : "1c", name :"Дані BAF + Панорама", is_active : true,},
			//	{type : "panorama", name :"Дані Panorama", is_active : false,},
				{type : "map", name :"Мапа", is_active : false,}
			],

			pai_info: {
				"has_err_1c" : true,
				"has_panorama_err"  : true,
				"is_1c_load" 		: false,
				"is_panorama_load"	: false,
				"data_1c": [],
				"data_panorama" : [],
			},

			feature_collection: {
				"type": "FeatureCollection",
				"features": []
			},
			map_div: "map_div_user",
			map_g: null,
			map_feature: null,
		}
	},

	mounted() {
		this.full_load();
	},
	methods : {

		setActiveTab(type) {
			this.active_tabs.map(item => {
				item.is_active = item.type === type;
			})
		},
		async full_load() {
			if(this.is_valid_kadastr) {
				this.loading_unit = true;

				this.load_pai().then(({data}) => {
					this.pai_info.is_panorama_load = true;
					if(data.status == 'operation_success') {
						this.pai_info.has_panorama_err = false;
						this.pai_info.data_panorama = data.data;
						EventBus.$emit("data_panorama_loaded");
					}
				}).catch(err => {
					this.pai_info.is_panorama_load = true;
				});

				this.load_pai("1c").then(({data}) => {
					this.pai_info.is_1c_load = true;
					if (data.status == 'operation_success') {
						this.pai_info.has_panorama_err = false;
						this.pai_info.data_1c = data.data;
						EventBus.$emit("data_1c_loaded");
					}

				}).catch(err => {
					this.pai_info.is_1c_load = true;
				});

			}
		},


		async load_pai(type = "db") {
			return await api.post('/pai_info',{
				"kadastr" : this.kadastr.field_val,
				"source" : type
			});
		},
	},
	computed : {
		draw_fields () {
			try {

				this.pai_item.fields.map(item => {
					if(item.field_type === 'doz_sum'){
						item.field_val_to_show = new Intl.NumberFormat().format(parseFloat(item.field_val.replace(",",".")))
					}
					else {
						item.field_val_to_show = item.field_val;
					}
				});

				return this.pai_item.fields;
			}
			catch (e) {

			}
		},

		current_tab () {
			let cur = null;
			this.active_tabs.map(item => {
				if(item.is_active) {
					cur = item;
				}
			})
			return cur;

		},

		finish_load()  {
			return this.pai_info.is_1c_load && this.pai_info.is_panorama_load;
		},

		is_valid_kadastr() {
			if(this.kadastr != null) {
				return this.kadastr.field_type === "kadastr" && this.kadastr.field_val.length === 22;
			}
			return false;
		},

		kadastr_v() {
			try {
				return this.kadastr.field_val;
			}
			catch (e) {

			}

			return "oops";
		},

		kadastr () {
			let res = null;
			this.draw_fields.map(item => {
				if(item.field_type === 'kadastr') {
					res =  item;
				}
			})
			return res;
		},
	}

}
</script>

<style scoped>
	.insd {
		margin-top: -15px;
	}
</style>
